import TrendingPost from './TrendingPost'

export default TrendingPost
